import { ALIEN_SPEED_FRAMES } from "../constants";

export const isMoveFrame = (frameCount: number) =>
    frameCount % ALIEN_SPEED_FRAMES === 0;
